import http, { HttpBodyUnpacking } from '@/lib/request.js'




export function query
(): HttpBodyUnpacking<string>
{
	return http.options('/authorize')

}

export function create
(value: string): HttpBodyUnpacking<void>
{
	return http.post('/authorize', { value })

}
